webpackJsonp([2,1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(9);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(107);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(99);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(106);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _router = __webpack_require__(21);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _filters = __webpack_require__(20);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _fastclick = __webpack_require__(83);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	(0, _keys2.default)(_filters2.default).forEach(function (k) {
	  _vue2.default.filter(k, _filters2.default[k]);
	});
	
	var router = new _vueRouter2.default();
	
	(0, _router2.default)(router);
	
	_fastclick2.default.attach(document.body);
	
	router.beforeEach(function (transition) {
	  if (transition.to.auth) {
	    if (localStorage.user_id) {
	      transition.next();
	    } else {
	      var redirect = encodeURIComponent(transition.to.path);
	      transition.redirect("/login?redirect=" + redirect);
	    }
	  } else {
	    transition.next();
	  }
	});
	router.start(_App2.default, 'app');

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reqwest = __webpack_require__(84);
	
	var _reqwest2 = _interopRequireDefault(_reqwest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = "https://cnodejs.org/api/v1/";
	
	exports.default = {
		topic: {
			getTopicList: function getTopicList(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "topics",
					method: "get",
					data: {
						page: opts.page,
						tab: opts.tab,
						limit: opts.limit,
						mdrender: opts.mdrender
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			getTopic: function getTopic(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "topic/" + opts._id,
					method: "get",
					data: {
						mdrender: opts.mdrender,
						accesstoken: opts.accesstoken
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			newTopic: function newTopic(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "topics",
					method: "post",
					data: {
						accesstoken: opts.accesstoken,
						title: opts.title,
						tab: opts.tab,
						content: opts.content
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			}
		},
		collect: {
			topicCollect: function topicCollect(opts, _callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "topic_collect/collect",
					method: "get",
					data: {
						accesstoken: opts.accesstoken,
						topic_id: opts.topic_id
					},
					callback: function callback(data) {
						_callback(opts);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			topicDeCollect: function topicDeCollect(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "topic_collect/de_collect",
					method: "post",
					data: {
						accesstoken: opts.accesstoken,
						topic_id: opts.topic_id
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			getUserCollect: function getUserCollect(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "topic_collect/" + opts.loginname,
					method: "get",
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			}
		},
		reply: {
			newReply: function newReply(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "topic/" + opts.topic_id + "/replies",
					method: "post",
					data: {
						accesstoken: opts.accesstoken,
						content: opts.content,
						reply_id: opts.reply_id },
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			ups: function ups(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "reply/" + opts.reply_id + "/ups",
					method: "post",
					data: {
						accesstoken: opts.accesstoken
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			}
		},
		user: {
			getUserInfo: function getUserInfo(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "user/" + opts.loginname,
					method: "get",
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			validateAccessToken: function validateAccessToken(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "accesstoken",
					method: "post",
					data: {
						accesstoken: opts.accesstoken
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			}
		},
		message: {
			getMessage: function getMessage(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "messages",
					method: "get",
					data: {
						accesstoken: opts.accesstoken,
						mdrender: opts.mdrender
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			unreadCount: function unreadCount(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "message/count",
					method: "get",
					data: {
						accesstoken: opts.accesstoken
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			},
			markAll: function markAll(opts, callback) {
				(0, _reqwest2.default)({
					url: apiUrl + "message/mark_all",
					method: "post",
					data: {
						accesstoken: opts.accesstoken
					},
					success: function success(data) {
						callback(data);
					},
					error: function error(err) {
						console.log(err);
					}
				});
			}
		}
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(75)
	__webpack_require__(66)
	__vue_script__ = __webpack_require__(28)
	__vue_template__ = __webpack_require__(91)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(71)
	__vue_script__ = __webpack_require__(30)
	__vue_template__ = __webpack_require__(87)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(81)
	__vue_script__ = __webpack_require__(29)
	__vue_template__ = __webpack_require__(97)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(79)
	__vue_script__ = __webpack_require__(31)
	__vue_template__ = __webpack_require__(95)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(82)
	__vue_script__ = __webpack_require__(32)
	__vue_template__ = __webpack_require__(98)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(80)
	__vue_script__ = __webpack_require__(33)
	__vue_template__ = __webpack_require__(96)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(74)
	__webpack_require__(69)
	__vue_script__ = __webpack_require__(36)
	__vue_template__ = __webpack_require__(90)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _utils = __webpack_require__(22);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		getLastTimeStr: function getLastTimeStr(time, friendly) {
			if (friendly) {
				return _utils2.default.MillisecondToDate(new Date() - new Date(time));
			} else {
				return _utils2.default.fmtDate(new Date(time), 'yyyy-MM-dd hh:mm');
			}
		}
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (router) {
	  router.map({
	    '/': {
	      name: 'list',
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      }
	    },
	    '*': {
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      }
	    },
	    '/list': {
	      name: 'list',
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      }
	    },
	    '/topic/:id': {
	      name: "topic",
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(18)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      }
	    },
	    "/message": {
	      name: " message",
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(16)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      },
	      auth: true
	    },
	    "/about": {
	      name: " about",
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(14)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      }
	    },
	    "/perinfo/:loginname": {
	      name: " perinfo",
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(105)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      }
	    },
	    "/login": {
	      name: " login",
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(15)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      }
	    },
	    "/newtopic": {
	      name: " newtopic",
	      component: function component(resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(17)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.call(this));
	      },
	      auth: true
	    }
	  });
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  fmtDate: function fmtDate(date, fmt) {
	    var o = {
	      "M+": date.getMonth() + 1,
	      "d+": date.getDate(),
	      "h+": date.getHours(),
	      "m+": date.getMinutes(),
	      "s+": date.getSeconds(),
	      "q+": Math.floor((date.getMonth() + 3) / 3),
	      "S": date.getMilliseconds() };
	    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	    for (var k in o) {
	      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
	    }return fmt;
	  },
	  MillisecondToDate: function MillisecondToDate(msd) {
	    var time = parseFloat(msd) / 1000;
	    var str = "";
	    if (null != time && "" != time) {
	      if (time > 60 && time < 3600) {
	        str = parseInt(time / 60.0) + " 分钟前";
	      } else if (time >= 3600 && time < 86400) {
	        str = parseInt(time / 3600.0) + " 小时前";
	      } else if (time >= 86400 && time < 86400 * 30) {
	        str = parseInt(time / 86400.0) + " 天前";
	      } else if (time >= 86400 * 30 && time < 86400 * 365) {
	        str = parseInt(time / (86400.0 * 30)) + " 个月前";
	      } else if (time >= 86400 * 365) {
	        str = parseInt(time / (86400.0 * 365)) + " 年前";
	      } else {
	        str = parseInt(time) + " 秒前";
	      }
	    }
	    return str;
	  }
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vHeader = __webpack_require__(101);
	
	var _vHeader2 = _interopRequireDefault(_vHeader);
	
	var _vSidebar = __webpack_require__(103);
	
	var _vSidebar2 = _interopRequireDefault(_vSidebar);
	
	var _vList = __webpack_require__(3);
	
	var _vList2 = _interopRequireDefault(_vList);
	
	var _vTopic = __webpack_require__(18);
	
	var _vTopic2 = _interopRequireDefault(_vTopic);
	
	var _vAbout = __webpack_require__(14);
	
	var _vAbout2 = _interopRequireDefault(_vAbout);
	
	var _vMessage = __webpack_require__(16);
	
	var _vMessage2 = _interopRequireDefault(_vMessage);
	
	var _vPerInfo = __webpack_require__(104);
	
	var _vPerInfo2 = _interopRequireDefault(_vPerInfo);
	
	var _vNewTopic = __webpack_require__(17);
	
	var _vNewTopic2 = _interopRequireDefault(_vNewTopic);
	
	var _vLogin = __webpack_require__(15);
	
	var _vLogin2 = _interopRequireDefault(_vLogin);
	
	var _vConfirm = __webpack_require__(100);
	
	var _vConfirm2 = _interopRequireDefault(_vConfirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    vheader: _vHeader2.default,
	    vsidebar: _vSidebar2.default,
	    vlist: _vList2.default,
	    vpost: _vTopic2.default,
	    vabout: _vAbout2.default,
	    vmessage: _vMessage2.default,
	    vperinfo: _vPerInfo2.default,
	    vnewpost: _vNewTopic2.default,
	    vlogin: _vLogin2.default,
	    vconfirm: _vConfirm2.default
	  },
	  data: function data() {
	    return {
	      title: "",
	      isShowSidebar: false,
	      currentView: "vlist",
	      postId: "",
	      tab: "all",
	      isShowConfirm: false,
	      isLogin: localStorage.loginname ? true : false,
	      loginname: localStorage.loginname,
	      avatar_url: localStorage.avatar_url,
	      accesstoken: localStorage.accesstoken,
	      unreadCount: 0,
	      scrollTop: 0
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var temTitle = "";
	    if (this.accesstoken) {
	      this.getUnreadCount();
	    }
	
	    this.$route.router.afterEach(function (transition) {
	
	      var router = transition.to;
	      var routerName = router.name.trim();
	      if (routerName === "list") {
	        switch (router.query.tab) {
	          case "all":
	            temTitle = "全部";break;
	          case "good":
	            temTitle = "精华";break;
	          case "share":
	            temTitle = "分享";break;
	          case "ask":
	            temTitle = "问答";break;
	          case "job":
	            temTitle = "招聘";break;
	          default:
	            temTitle = "全部";
	        }
	      } else {
	        if (routerName === "message") temTitle = "消息";else if (routerName === "about") temTitle = "关于";else if (routerName === "perinfo") temTitle = "个人信息";else if (routerName === "login") temTitle = "登录";else if (routerName === "newtopic") temTitle = "发帖";
	      }
	      _this.title = temTitle;
	      _this.scrollTop = 0;
	    });
	  },
	  compiled: function compiled() {
	    console.log("aasdadasds");
	  },
	  watch: {
	    isShowSidebar: function isShowSidebar() {
	      var _this2 = this;
	
	      if (this.isShowSidebar) {
	        this.scrollTop = document.body.scrollTop;
	        console.log(document.body.scrollTop);
	        document.body.style.marginTop = -this.scrollTop + "px";
	        document.querySelector("header").style.marginTop = this.scrollTop + "px";
	        document.body.style.position = "fixed";
	      } else {
	
	        setTimeout(function () {
	          document.body.style.position = "static";
	          document.querySelector("header").style.marginTop = 0 + "px";
	          document.body.style.marginTop = 0 + "px";
	          document.body.scrollTop = _this2.scrollTop;
	        }, 300);
	      }
	    }
	  },
	  methods: {
	    showConfirm: function showConfirm() {
	      this.isShowConfirm = !this.isShowConfirm;
	    },
	    getUnreadCount: function getUnreadCount() {
	      var _this3 = this;
	
	      _api2.default.message.unreadCount({
	        accesstoken: this.accesstoken
	      }, function (data) {
	        _this3.unreadCount = data.data;
	      });
	    }
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: {
			isShowConfirm: {
				type: Boolean,
				required: true,
				twoWay: true
			},
			isShowSidebar: {
				type: Boolean,
				required: true,
				twoWay: true
			},
			isLogin: {
				type: Boolean,
				required: true,
				twoWay: true
			}
		},
		methods: {
			hide: function hide() {
				this.isShowConfirm = false;
			},
			confirmHandler: function confirmHandler() {
				localStorage.loginname = localStorage.avatar_url = localStorage.user_id = localStorage.accesstoken = "";
				this.isShowConfirm = false;
				this.isShowSidebar = false;
				this.isLogin = false;
				this.$route.router.go({ path: "/list" });
			}
		}
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      default: "CNode.js",
	      required: true
	    },
	    isShowSidebar: {
	      type: Boolean,
	      default: false,
	      required: true,
	      twoway: true
	    }
	  },
	  methods: {
	    toggleSidebar: function toggleSidebar() {
	      this.isShowSidebar = true;
	    }
	  }
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vUserPanel = __webpack_require__(2);
	
	var _vUserPanel2 = _interopRequireDefault(_vUserPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    vuserpanel: _vUserPanel2.default
	  },
	  data: function data() {
	    return {
	      replyContent: ""
	    };
	  },
	
	  props: {
	    replies: {
	      type: Array,
	      required: true
	    },
	    accesstoken: {
	      type: String,
	      required: true
	    },
	    topicId: {
	      type: String,
	      required: true
	    },
	    loginname: {
	      type: String,
	      required: true
	    }
	  },
	
	  methods: {
	    toggleReply: function toggleReply(index) {
	
	      var reply = this.replies[index];
	      this.replies.forEach(function (r, i) {
	        if (i !== index) {
	          r.isShowReply = false;
	        }
	      });
	      reply.isShowReply = !reply.isShowReply;
	    },
	    replyToComment: function replyToComment(index) {
	      var _this = this;
	
	      if (!this.$root.isLogin) {
	        var link = "/login?redirect=" + encodeURIComponent(this.$route.path);
	        this.$route.router.go(link);
	        return;
	      }
	
	      var replyId = this.replies[index].id;
	
	      _api2.default.reply.newReply({
	        accesstoken: this.accesstoken,
	        topic_id: this.topicId,
	        content: this.replyContent,
	        reply_id: replyId
	      }, function (data) {
	        if (data.success) {
	          _this.$parent.getTopic(_this.topicId);
	        }
	      });
	    },
	    toggleUps: function toggleUps(index) {
	      var _this2 = this;
	
	      if (!this.$root.isLogin) {
	        var link = "/login?redirect=" + encodeURIComponent(this.$route.path);
	        this.$route.router.go(link);
	        return;
	      }
	
	      var reply = this.replies[index];
	
	      if (this.loginname !== reply.author.loginname) {
	        _api2.default.reply.ups({
	          reply_id: reply.id,
	          accesstoken: this.accesstoken
	        }, function (data) {
	          if (data.success) {
	            if (data.action === "down") {
	              var index = reply.ups.indexOf(_this2.topicId);
	              reply.ups.splice(index, 1);
	            } else {
	              reply.ups.push(_this2.topicId);
	            }
	          }
	        });
	      } else {
	        alert("不能为自己点赞哦。^_^");
	      }
	    }
	  }
	};

/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      tab: this.$route.query.tab,
	      itemSet: [[{
	        icon: "&#xe602;",
	        name: "全部",
	        view: "list",
	        tab: "all"
	      }, {
	        icon: "&#xe605;",
	        name: "精华",
	        view: "list",
	        tab: "good"
	      }, {
	        icon: "&#xe600;",
	        name: "分享",
	        view: "list",
	        tab: "share"
	      }, {
	        icon: "&#xe608;",
	        name: "问答",
	        view: "list",
	        tab: "ask"
	      }, {
	        icon: "&#xe606;",
	        name: "招聘",
	        view: "list",
	        tab: "job"
	      }], [{
	        icon: "&#xe607;",
	        name: "消息",
	        view: "message"
	      }, {
	        icon: "&#xe608;",
	        name: "关于",
	        view: "about"
	      }]]
	    };
	  },
	
	
	  props: {
	    isShowSidebar: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    },
	    isShowConfirm: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    },
	    isLogin: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    },
	    avatar_url: {
	      type: String,
	      required: true,
	      twoWay: true
	    },
	    loginname: {
	      type: String,
	      required: true,
	      twoWay: true
	    },
	    title: {
	      type: String,
	      required: true,
	      twoWay: true
	    },
	    unreadCount: {
	      type: Number,
	      required: true,
	      twoWay: true,
	      default: 0
	    }
	  },
	  methods: {
	    hide: function hide() {
	      this.isShowSidebar = false;
	    },
	    change: function change(tab) {
	      if (tab == undefined && event.currentTarget.dataset.view == "logout") {
	        this.isShowConfirm = true;
	      }
	      this.tab = tab;
	    },
	    goEnter: function goEnter() {
	      var link = "";
	      var redirect = this.$route.query.redirect;
	      if (this.$route.path !== "login" && !redirect) {
	        link = "/login?redirect=" + encodeURIComponent(this.$route.path);
	        this.$route.router.go(link);
	      } else {
	        this.isShowSidebar = false;
	      }
	    },
	    goUser: function goUser() {
	      this.$route.router.go({ path: "/perinfo/" + this.loginname });
	      this.hide();
	    },
	    logout: function logout(event) {
	      this.isShowConfirm = true;
	    }
	  }
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: {
			avatar: {
				type: String,
				required: true
			}
		}
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: {
			isShowSidebar: {
				type: Boolean,
				twoway: true
			}
		},
		created: function created() {
			this.isShowSidebar = false;
		}
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vUserPanel = __webpack_require__(2);
	
	var _vUserPanel2 = _interopRequireDefault(_vUserPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			vuserpanel: _vUserPanel2.default
		},
		data: function data() {
			return {
				topics: [],
				page: 1,
				limit: 30,
				tab: "all",
				isFirstLoad: true,
				isLoading: false
			};
		},
	
		props: {
			isShowSidebar: {
				required: true,
				twoWay: true
			}
		},
		route: {
			data: function data(transition) {
				var query = transition.to.query;
				if (transition.to.name === "list") {
					this.limit = 30;
					this.tab = query.tab;
					this.getTopicList({ tab: this.tab });
					this.isShowSidebar = false;
				}
			}
		},
	
		methods: {
			tabToName: function tabToName(topic) {
				var name = "";
				if (topic.good == true) {
					name = "精华";
				} else {
					switch (topic.tab) {
						case "ask":
							name = "问答";break;
						case "share":
							name = "分享";break;
						case "job":
							name = "招聘";break;
						default:
							name = "未知";
					}
				}
				return name;
			},
			getTopicList: function getTopicList(opts) {
				var _this = this;
	
				if (opts == undefined) {
					opts = {};
				}
				_api2.default.topic.getTopicList({
					tab: opts.tab || this.tab,
					page: opts.page || this.page,
					limit: opts.limit || this.limit
				}, function (data) {
					if (data.success) {
						_this.topics = data.data;
						_this.isLoading = false;
						if (_this.isFirstLoad) {
							_this.isFirstLoad = false;
						}
					}
				});
			},
			getMoreTopic: function getMoreTopic() {
				if (!this.isLoading) {
					this.isLoading = true;
					this.limit += 30;
					this.getTopicList({ tab: this.tab });
				}
			}
		}
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				accessTokenInput: ""
			};
		},
	
		props: {
			isShowSidebar: {
				type: Boolean,
				required: true,
				twoWay: true
			},
			isLogin: {
				type: Boolean,
				required: true,
				twoWay: true
			},
			loginname: {
				type: String,
				required: true,
				twoWay: true
			},
			avatar_url: {
				type: String,
				required: true,
				twoWay: true
			},
			accesstoken: {
				type: String,
				required: true,
				twoWay: true
			}
		},
		created: function created() {
			this.isShowSidebar = false;
		},
	
		methods: {
			signIn: function signIn() {
				var _this = this;
	
				this.accesstoken = this.accessTokenInput.trim();
				if (this.accesstoken.length > 0) {
					_api2.default.user.validateAccessToken({
						accesstoken: this.accessTokenInput
					}, function (data) {
						if (data.success) {
							localStorage.loginname = _this.loginname = data.loginname;
							localStorage.avatar_url = _this.avatar_url = data.avatar_url;
							localStorage.user_id = data.id;
							localStorage.accesstoken = _this.accesstoken = _this.accessTokenInput;
	
							_this.isLogin = true;
							var redirect = decodeURIComponent(_this.$route.query.redirect || '/');
							_this.$route.router.go(redirect);
						}
					});
				}
			}
		}
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _keys = __webpack_require__(9);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vUserPanel = __webpack_require__(2);
	
	var _vUserPanel2 = _interopRequireDefault(_vUserPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			vuserpanel: _vUserPanel2.default
		},
		data: function data() {
			return {
				activeItem: 0,
				allMessages: []
			};
		},
	
		props: {
			isShowSidebar: {
				type: Boolean,
				required: true,
				twoway: true
			},
			accesstoken: {
				type: String,
				required: true
			},
			unreadCount: {
				type: Number,
				required: true,
				twoWay: true,
				default: 0
			}
		},
		created: function created() {
			this.getMessages();
			this.$root.getUnreadCount();
			this.isShowSidebar = false;
		},
	
		methods: {
			changeItem: function changeItem(itemIndex) {
				this.activeItem = itemIndex;
			},
			getMessages: function getMessages() {
				var _this = this;
	
				_api2.default.message.getMessage({
					accesstoken: this.accesstoken
				}, function (data) {
					(0, _keys2.default)(data.data).forEach(function (item, index) {
						_this.allMessages.$set(index, data.data[item]);
					});
				});
			},
			makeAllRead: function makeAllRead() {
				var _this2 = this;
	
				_api2.default.message.markAll({
					accesstoken: this.accesstoken
				}, function (data) {
					if (data.success) {
						_this2.unreadCount = 0;
						_this2.getMessages();
					}
				});
			}
		}
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				tabSelected: "",
				tabOptions: [{ text: "请选择", value: "" }, { text: "分享", value: "share" }, { text: "问答", value: "ask" }, { text: "招聘", value: "job" }],
				postTitle: "",
				postContent: ""
			};
		},
	
		props: {
			isShowSidebar: {
				type: Boolean,
				required: true,
				twoway: true
			},
			accesstoken: {
				type: String,
				required: true
			}
		},
		created: function created() {
			this.isShowSidebar = false;
		},
	
		methods: {
			newPost: function newPost() {
				var _this = this;
	
				if (this.tabSelected === "") {
					alert("未选择主题类型");
				} else if (this.postTitle.trim().length < 10) {
					alert("标题小于10个字");
				} else if (this.postContent.trim().length <= 0) {
					alert("主题内容为空");
				} else {
					_api2.default.topic.newTopic({
						accesstoken: this.accesstoken,
						title: this.postTitle,
						content: this.postContent,
						tab: this.tabSelected
					}, function (data) {
						_this.$route.router.go({ name: "list" });
					});
				}
			}
		}
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vUserPanel = __webpack_require__(2);
	
	var _vUserPanel2 = _interopRequireDefault(_vUserPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    vuserpanel: _vUserPanel2.default
	  },
	  data: function data() {
	    return {
	      activeItem: 0,
	      userInfo: {},
	      tabDataSet: []
	    };
	  },
	
	  props: {
	    isShowSidebar: {
	      type: Boolean,
	      required: true,
	      twoway: true
	    },
	    loginname: {
	      type: String,
	      required: true
	    }
	  },
	  created: function created() {
	    this.isShowSidebar = false;
	    this.getUserInfo();
	  },
	
	  route: {
	    data: function data(transition) {
	      this.getUserInfo();
	    }
	  },
	  methods: {
	    changeItem: function changeItem(itemIndex) {
	      this.activeItem = itemIndex;
	    },
	    getUserInfo: function getUserInfo() {
	      var _this = this;
	
	      _api2.default.user.getUserInfo({
	        loginname: this.$route.params.loginname || this.loginname
	      }, function (data) {
	        _this.userInfo = data.data;
	        _this.tabDataSet.$set(0, data.data.recent_topics);
	        _this.tabDataSet.$set(1, data.data.recent_replies);
	      });
	    }
	  }
	};

/***/ },
/* 35 */,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(1);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _vReplyList = __webpack_require__(102);
	
	var _vReplyList2 = _interopRequireDefault(_vReplyList);
	
	var _vUserPanel = __webpack_require__(2);
	
	var _vUserPanel2 = _interopRequireDefault(_vUserPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    vreplylist: _vReplyList2.default,
	    vuserpanel: _vUserPanel2.default
	  },
	  data: function data() {
	    return {
	      topic: {},
	      replyContent: ""
	    };
	  },
	
	  props: {
	    accesstoken: {
	      type: String,
	      reuqired: true,
	      twoWay: true
	    },
	    loginname: {
	      type: String,
	      reuqired: true
	    }
	  },
	  route: {
	    data: function data(transition) {
	      var topicId = transition.to.params.id;
	      this.getTopic(topicId);
	    }
	  },
	  methods: {
	    tabToName: function tabToName(tab) {
	      var name = "";
	      switch (tab) {
	        case "good":
	          name = "置顶";break;
	        case "ask":
	          name = "问答";break;
	        case "share":
	          name = "分享";break;
	        case "job":
	          name = "招聘";break;
	        default:
	          name = "未能识别";
	      }
	      return name;
	    },
	    getTopic: function getTopic(id) {
	      var _this = this;
	
	      _api2.default.topic.getTopic({
	        _id: id
	      }, function (data) {
	        data.data.replies.forEach(function (reply, index) {
	          reply.isShowReply = false;
	        });
	        _this.topic = data.data;
	      });
	    },
	    replyHandler: function replyHandler() {
	      var _this2 = this;
	
	      _api2.default.reply.newReply({
	        accesstoken: this.accesstoken,
	        topic_id: this.topicId,
	        content: this.replyContent
	      }, function (data) {
	        if (data.success) {
	          _this2.getTopic();
	        }
	      });
	    }
	  }
	};

/***/ },
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 66 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 67 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 68 */,
/* 69 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 70 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 71 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 72 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 73 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 74 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 75 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 76 */,
/* 77 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 78 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 79 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 80 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 81 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 82 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 83 */,
/* 84 */,
/* 85 */
/***/ function(module, exports) {

	module.exports = " <div id=app :class=\"{ 'offcanvas-page': isShowSidebar, 'show-offcanvas': isShowSidebar}\"> <vsidebar :is-show-sidebar.sync=isShowSidebar :is-show-confirm.sync=isShowConfirm :is-login.sync=isLogin :title.sync=title :avatar_url.sync=avatar_url :loginname.sync=loginname :unread-count.sync=unreadCount></vsidebar> <main> <vheader :title=title :is-show-sidebar.sync=isShowSidebar :show.sync=showConfirm></vheader> <div id=content> <router-view :is-show-sidebar.sync=isShowSidebar :is-login.sync=isLogin :avatar_url.sync=avatar_url :loginname.sync=loginname :accesstoken.sync=accesstoken :unread-count.sync=unreadCount keep-alive></router-view> </div> </main> <vconfirm :is-show-confirm.sync=isShowConfirm :is-show-sidebar.sync=isShowSidebar :is-login.sync=isLogin> <h3 slot=body>确认注销当前账号吗？</h3> </vconfirm> </div> ";

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = " <div class=confirm v-show=isShowConfirm transition=confirm _v-07f8688c=\"\"> <div class=confirm-dialog _v-07f8688c=\"\"> <div class=confirm-body _v-07f8688c=\"\"> <slot name=body _v-07f8688c=\"\"></slot> </div> <div class=\"confirm-footer clearfix\" _v-07f8688c=\"\"> <slot name=footer _v-07f8688c=\"\"> <div class=cancelBtn @click=hide _v-07f8688c=\"\">取消</div> <div class=confirmBtn @click=confirmHandler _v-07f8688c=\"\">确认</div> </slot> </div> </div> </div> ";

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = " <div class=topic-list :is-show-sidebar.sync=false _v-083802e0=\"\"> <ul _v-083802e0=\"\"> <li v-for=\"topic in topics\" :class=\"topic.good ? 'top' : (topic.tab || 'unknow')\" :id=topic.id v-link=\"{name: 'topic', params: {id: topic.id}}\" _v-083802e0=\"\"> <h3 class=title _v-083802e0=\"\"><span class=tab _v-083802e0=\"\">{{tabToName(topic)}}</span>{{topic.title}}</h3> <div class=info _v-083802e0=\"\"> <div class=right _v-083802e0=\"\"> <p _v-083802e0=\"\"><strong title=回复数 _v-083802e0=\"\">{{topic.reply_count}}</strong> / <span title=阅读数 _v-083802e0=\"\">{{topic.visit_count}}</span></p> <p class=latest_reply_time _v-083802e0=\"\">{{topic.last_reply_at | getLastTimeStr true}}</p> </div> <vuserpanel :avatar=topic.author.avatar_url _v-083802e0=\"\"> <p slot=one v-link=\"{path: '/perinfo/' + topic.author.loginname}\" _v-083802e0=\"\">{{topic.author.loginname}}</p> <p slot=two _v-083802e0=\"\">{{topic.create_at | getLastTimeStr true}}</p> </vuserpanel> </div> </li> </ul> </div> <button v-if=!isFirstLoad type=button class=loadMoreBtn @click=getMoreTopic _v-083802e0=\"\">{{isLoading ? \"正在加载\" :\"加载更多\"}}</button> ";

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = " <div class=reply-list _v-15425322=\"\"> <div class=header _v-15425322=\"\"> <h4 _v-15425322=\"\">评论 已有<span _v-15425322=\"\"> {{replies.length}} </span>回复</h4> </div> <ul v-if=\"replies.length > 0\" _v-15425322=\"\"> <li v-for=\"reply in replies\" _v-15425322=\"\"> <div class=user _v-15425322=\"\"> <div class=right _v-15425322=\"\"> <div class=like-btn @click=toggleUps($index) _v-15425322=\"\"> <i class=iconfont _v-15425322=\"\"></i>{{reply.ups.length}} </div> <div class=reply-btn @click=toggleReply($index) _v-15425322=\"\"> <i class=iconfont _v-15425322=\"\"></i> </div> </div> <vuserpanel :avatar=reply.author.avatar_url _v-15425322=\"\"> <p slot=one _v-15425322=\"\">{{reply.author.loginname}}</p> <p slot=two _v-15425322=\"\">回复时间：{{reply.create_at | getLastTimeStr true}}</p> </vuserpanel> </div> <div class=reply-content _v-15425322=\"\"> {{{reply.content}}} </div> <div class=reply-form v-if=reply.isShowReply _v-15425322=\"\"> <form @submit.prevent=replyToComment($index) _v-15425322=\"\"> <textarea v-model=replyContent _v-15425322=\"\">@{{reply.author.loginname}} </textarea> <button type=submit _v-15425322=\"\">确定</button> </form> </div> </li> </ul> </div> ";

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = " <header _v-32f32003=\"\"> <div class=navbar-toggle id=show-offcanvas @click=toggleSidebar _v-32f32003=\"\"> <i class=iconfont _v-32f32003=\"\"></i> </div> <div class=send-btn title=发帖 v-link=\"{path: '/newtopic'}\" _v-32f32003=\"\"> <i class=iconfont _v-32f32003=\"\"></i> </div> <h2 _v-32f32003=\"\">{{title}}</h2> </header> ";

/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports = " <div _v-394efda6=\"\"> <div class=topic-header _v-394efda6=\"\"> <h3 _v-394efda6=\"\">{{topic.title}}</h3> <div class=right _v-394efda6=\"\"> <p class=\"tab top\" _v-394efda6=\"\">{{tabToName(topic.tab)}}</p> <p _v-394efda6=\"\">{{topic.visit_count}}次浏览</p> </div> <vuserpanel :avatar=topic.author.avatar_url _v-394efda6=\"\"> <p slot=one _v-394efda6=\"\">{{topic.author.loginname}}</p> <p slot=two _v-394efda6=\"\">发布时间：{{topic.create_at | getLastTimeStr true}}</p> </vuserpanel> </div> <div class=topic-content _v-394efda6=\"\"> {{{topic.content}}} </div> <vreplylist :replies=topic.replies :topic-id=topic.id :accesstoken=accesstoken :loginname=loginname _v-394efda6=\"\"></vreplylist> <div _v-394efda6=\"\"> <form @submit.prevent=replyHandler class=reply-form _v-394efda6=\"\"> <textarea v-model=replyContent _v-394efda6=\"\"></textarea> <button type=submit _v-394efda6=\"\">回复</button> </form> </div> </div> ";

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports = " <div class=userPanel _v-5714e4f3=\"\"> <img :src=avatar alt=\"\" _v-5714e4f3=\"\"> <div _v-5714e4f3=\"\"> <slot name=one _v-5714e4f3=\"\"></slot> <slot name=two _v-5714e4f3=\"\"></slot> </div> </div> ";

/***/ },
/* 92 */,
/* 93 */
/***/ function(module, exports) {

	module.exports = " <div class=offcanvas @click=hide _v-61fd7b54=\"\"> <nav class=offcanvas-bar @click.stop=\"\" _v-61fd7b54=\"\"> <div class=user _v-61fd7b54=\"\"> <div v-if=isLogin @click=goUser _v-61fd7b54=\"\"> <img :src=avatar_url alt=\"\" _v-61fd7b54=\"\"> <p _v-61fd7b54=\"\">Jchehe</p> </div> <a v-else=\"\" @click=goEnter class=login _v-61fd7b54=\"\"><i class=iconfont _v-61fd7b54=\"\"></i>登录</a> </div> <ul v-for=\"(index, items) in itemSet\" _v-61fd7b54=\"\"> <li v-for=\"item in items\" v-link=\"{path: '/'+item.view, query:{'tab': item.tab}}\" :class=\"{'active': item.tab == tab, 'tab': item.tab, 'unread': (item.view === 'message' &amp;&amp; unreadCount > 0)}\" @click=change(item.tab) _v-61fd7b54=\"\"> <a href=javascript:; _v-61fd7b54=\"\"> <i class=iconfont _v-61fd7b54=\"\">{{{item.icon}}}</i> {{item.name}} <span class=unreadTip v-if=\"item.view==='message' &amp;&amp; unreadCount !== 0\" _v-61fd7b54=\"\">( {{unreadCount}} )</span> </a> </li> <li v-if=\"isLogin &amp;&amp; index==itemSet.length -1\" _v-61fd7b54=\"\"><a @click=logout _v-61fd7b54=\"\"><i class=iconfont _v-61fd7b54=\"\"></i> 注销</a></li> </ul> <div class=logo _v-61fd7b54=\"\"> <img src=//o4j806krb.qnssl.com/public/images/cnodejs_light.svg alt=\"\" _v-61fd7b54=\"\"> </div> </nav> </div> ";

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = " <div _v-622047e9=\"\"> <div class=user-info _v-622047e9=\"\"> <img :src=userInfo.avatar_url _v-622047e9=\"\"> <p _v-622047e9=\"\">{{userInfo.loginname}}</p> <div class=right _v-622047e9=\"\"> <p _v-622047e9=\"\">注册时间：{{userInfo.create_at | getLastTimeStr true}}</p> <p _v-622047e9=\"\">积分：{{userInfo.score}}</p> </div> </div> </div> <div class=tab _v-622047e9=\"\"> <ul class=tab-nav _v-622047e9=\"\"> <li v-for=\"tabItem in tabDataSet\" :class=\"{'active': activeItem === $index}\" @click=changeItem($index) _v-622047e9=\"\">{{ $index === 0 ? \"创建的话题\" : \"参与的话题\"}}</li> </ul> <div class=tab-content _v-622047e9=\"\"> <div v-for=\"tabData in tabDataSet\" class=tabpanel :class=\"{'active': activeItem === $index}\" _v-622047e9=\"\"> <ul _v-622047e9=\"\"> <li v-for=\"item in tabData\" _v-622047e9=\"\"> <div class=header _v-622047e9=\"\"> <vuserpanel :avatar=item.author.avatar_url _v-622047e9=\"\"> <p slot=one v-link=\"{path: '/perinfo/' + item.author.loginname}\" _v-622047e9=\"\">{{item.author.loginname}}</p> <p slot=two v-link=\"{path: '/topic/' + item.id}\" _v-622047e9=\"\">{{item.title}}</p> </vuserpanel> <div class=right _v-622047e9=\"\"> <p class=date _v-622047e9=\"\">{{item.last_reply_at | getLastTimeStr true}}</p> </div> </div> </li> </ul> </div> </div> </div> ";

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = " <form @submit.prevent=signIn _v-65b7f667=\"\"> <div class=form-group _v-65b7f667=\"\"> <input type=text v-model=accessTokenInput placeholder=请输入access_token _v-65b7f667=\"\"> </div> <button type=submit _v-65b7f667=\"\">登录</button> </form> ";

/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = " <form @submit.prevent=newPost _v-6851f7e1=\"\"> <div class=form-group _v-6851f7e1=\"\"> <label _v-6851f7e1=\"\"> 选择板块： <select v-model=tabSelected _v-6851f7e1=\"\"> <option v-for=\"tabOpt in tabOptions\" :value=tabOpt.value _v-6851f7e1=\"\">{{tabOpt.text}}</option> </select> </label> </div> <div class=form-group _v-6851f7e1=\"\"> <input v-model=postTitle type=text name=title placeholder=标题，字数10字以上 _v-6851f7e1=\"\"> </div> <div class=form-group _v-6851f7e1=\"\"> <textarea v-model=postContent placeholder=支持Markdown语法 _v-6851f7e1=\"\"></textarea> </div> <button type=submit _v-6851f7e1=\"\">发布</button> </form> ";

/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports = " <ul _v-7c58788b=\"\"> <li _v-7c58788b=\"\"> <h4 _v-7c58788b=\"\">关于项目</h4> <p _v-7c58788b=\"\">该项目是我出于学习实践的目的，采用Vue.js（1.0），并基于CNodejs.org的API编写的Web App。</p> </li> <li _v-7c58788b=\"\"> <h4 _v-7c58788b=\"\">源码地址</h4> <p _v-7c58788b=\"\"><a href=https://github.com/JChehe/vue_cnode target=_blank _v-7c58788b=\"\">https://github.com/JChehe/vue_cnode</a></p> </li> <li _v-7c58788b=\"\"> <h4 _v-7c58788b=\"\">意见反馈</h4> <p _v-7c58788b=\"\"><a href=https://github.com/JChehe/vue_cnode/issues target=_blank _v-7c58788b=\"\">发表意见或者提需求</a></p> </li> <li _v-7c58788b=\"\"> <h4 _v-7c58788b=\"\">当前版本</h4> <p _v-7c58788b=\"\">V1.0 beta</p> </li> </ul> ";

/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports = " <div class=tab _v-d7c232f6=\"\"> <ul class=tab-nav _v-d7c232f6=\"\"> <li v-for=\"messageType in allMessages\" :class=\"{'active': activeItem === $index}\" @click=changeItem($index) _v-d7c232f6=\"\">{{ $index === 0 ? \"已读信息\" : \"未读信息\"}} <span v-if=\"$index===1 &amp;&amp; unreadCount > 0\" _v-d7c232f6=\"\">( {{unreadCount}} )</span></li> </ul> <div class=tab-content _v-d7c232f6=\"\"> <div class=tabpanel v-for=\"messageType in allMessages\" :class=\"{'active': activeItem === $index}\" _v-d7c232f6=\"\"> <button v-if=\"$index===1 &amp;&amp; unreadCount > 0\" @click=makeAllRead _v-d7c232f6=\"\">标为全部已读</button> <ul _v-d7c232f6=\"\"> <li v-for=\"message in messageType\" _v-d7c232f6=\"\"> <div class=header _v-d7c232f6=\"\"> <div class=right _v-d7c232f6=\"\"> <p _v-d7c232f6=\"\">{{message.reply.create_at | getLastTimeStr true}}</p> </div> <vuserpanel :avatar=message.author.avatar_url _v-d7c232f6=\"\"> <p slot=one v-link=\"{path:'/perinfo/'+message.author.loginname}\" _v-d7c232f6=\"\">{{message.author.loginname}}</p> <p slot=two _v-d7c232f6=\"\">在回复中@了你</p> </vuserpanel> </div> <div class=content _v-d7c232f6=\"\"> <div class=\"\" _v-d7c232f6=\"\"> {{{message.reply.content}}} </div> <div class=related-topic v-link=\"{path: '/topic/' + message.topic.id}\" _v-d7c232f6=\"\"> <h4 _v-d7c232f6=\"\">{{message.topic.title}}</h4> </div> </div> </li> </ul> </div> </div> </div> ";

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(65)
	__vue_script__ = __webpack_require__(23)
	__vue_template__ = __webpack_require__(85)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(70)
	__vue_script__ = __webpack_require__(24)
	__vue_template__ = __webpack_require__(86)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(73)
	__vue_script__ = __webpack_require__(25)
	__vue_template__ = __webpack_require__(89)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(72)
	__vue_script__ = __webpack_require__(26)
	__vue_template__ = __webpack_require__(88)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(77)
	__vue_script__ = __webpack_require__(27)
	__vue_template__ = __webpack_require__(93)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(78)
	__webpack_require__(67)
	__vue_script__ = __webpack_require__(34)
	__vue_template__ = __webpack_require__(94)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.2b8b01a6338e994e4e9d.js
 **/